<form novalidate [formGroup]="form">
    <div class="report-container">
        <!-- Header Section -->
        <div class="header-section">
            <h6 class="section-title">
                <i class="fas fa-chart-line me-2"></i>
                Generador de Reportes
            </h6>
            
            <div class="store-selector">
                <label for="cities_id" class="form-label">Dependencia</label>
                <div class="input-group input-group-sm">
                    <select id="cities_id" class="form-select" formControlName="stores_id">
                        <option value="0">TODAS</option>
                        <option *ngFor="let item of stores" value="{{item.id}}">{{item.name}}</option>
                    </select>
                    <button type="button" class="btn btn-success btn-sm" (click)="generateReport(mdlReport)"
                        title="Generar Excel">
                        <i class="fas fa-file-excel"></i>
                    </button>
                    <button type="button" class="btn btn-danger btn-sm" (click)="generateReportPdf(mdlReport)"
                        title="Generar PDF">
                        <i class="fas fa-file-pdf"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- Data Types Section -->
        <div class="section">
            <h6 class="section-subtitle">
                <i class="fas fa-database me-2"></i>
                Tipos de Datos
            </h6>
            
            <div class="switches-grid">
                <div class="switch-item">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="users" formControlName="users" checked>
                        <label class="form-check-label" for="users">
                            <i class="fas fa-user-shield me-1"></i>
                            Administradores
                        </label>
                    </div>
                </div>
                
                <div class="switch-item">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="employees" formControlName="employees" checked>
                        <label class="form-check-label" for="employees">
                            <i class="fas fa-users me-1"></i>
                            Res. / Emp.
                        </label>
                    </div>
                </div>
                
                <div class="switch-item">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="providers" formControlName="providers" checked>
                        <label class="form-check-label" for="providers">
                            <i class="fas fa-truck me-1"></i>
                            Proveedores
                        </label>
                    </div>
                </div>
                
                <div class="switch-item">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="visitors" formControlName="visitors" checked>
                        <label class="form-check-label" for="visitors">
                            <i class="fas fa-user-friends me-1"></i>
                            Visitantes
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <!-- Columns Section -->
        <div class="section">
            <h6 class="section-subtitle">
                <i class="fas fa-columns me-2"></i>
                Columnas a Incluir
            </h6>
            
            <div class="switches-grid">
                <div class="switch-item">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="name" formControlName="name" checked>
                        <label class="form-check-label" for="name">
                            <i class="fas fa-user me-1"></i>
                            Nombre
                        </label>
                    </div>
                </div>
                
                <div class="switch-item">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="lastname" formControlName="lastname" checked>
                        <label class="form-check-label" for="lastname">
                            <i class="fas fa-user-tag me-1"></i>
                            Apellidos
                        </label>
                    </div>
                </div>
                
                <div class="switch-item">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="rut" formControlName="rut" checked>
                        <label class="form-check-label" for="rut">
                            <i class="fas fa-id-card me-1"></i>
                            RUT
                        </label>
                    </div>
                </div>
                
                <div class="switch-item">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="phone" formControlName="phone" checked>
                        <label class="form-check-label" for="phone">
                            <i class="fas fa-phone me-1"></i>
                            Teléfono
                        </label>
                    </div>
                </div>
                
                <div class="switch-item">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="email" formControlName="email" checked>
                        <label class="form-check-label" for="email">
                            <i class="fas fa-envelope me-1"></i>
                            Correo
                        </label>
                    </div>
                </div>
                
                <div class="switch-item">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="state_id" formControlName="state_id" checked>
                        <label class="form-check-label" for="state_id">
                            <i class="fas fa-toggle-on me-1"></i>
                            Estado
                        </label>
                    </div>
                </div>
                
                <div class="switch-item">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="created_at" formControlName="created_at" checked>
                        <label class="form-check-label" for="created_at">
                            <i class="fas fa-calendar-alt me-1"></i>
                            F. creación
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

<!-- Modal Template -->
<ng-template #mdlReport let-c="close" let-d="dismiss">
    <div class="modal-content modern-modal">
        <div class="modal-header">
            <h5 class="modal-title">
                <i class="fas fa-spinner fa-spin me-2" *ngIf="loading"></i>
                <i class="fas fa-download me-2" *ngIf="!loading"></i>
                {{loading ? "Generando reporte..." : "Descargar Reporte"}}
            </h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        </div>
        
        <div class="modal-body text-center">
            <div *ngIf="loading" class="loading-state">
                <div class="spinner-border text-primary mb-3" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
                <p class="text-muted">Procesando información...</p>
            </div>
            
            <div *ngIf="!loading" class="download-state">
                <div class="download-icon mb-3">
                    <i class="fas fa-file-download text-success" style="font-size: 3rem;"></i>
                </div>
                <p class="mb-3">Tu reporte está listo para descargar</p>
                <a [href]="pathDownload" [download]="pathDownload" target="_blank" 
                   class="btn btn-success btn-lg">
                    <i class="fas fa-download me-2"></i>
                    Descargar Archivo
                </a>
            </div>
        </div>
        
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">
                Cerrar
            </button>
        </div>
    </div>
</ng-template>